import React from 'react'
import { CircularProgress, Stack, Typography } from '@mui/material'
import IconBox from './IconBox'

type IconProp = React.ElementType | React.ReactNode

interface IDashboardMainInfoItem {
  readonly isLoading: boolean
  readonly title: string
  readonly value: number | string
  readonly Icon?: IconProp
  readonly iconBackgroundColor?: string
  readonly noIcon?: boolean
  readonly textColor?: string
}

const DashboardMainInfoItem = ({
  isLoading,
  title,
  value,
  Icon,
  iconBackgroundColor,
  noIcon = false,
  textColor = 'textSecondary',
}: IDashboardMainInfoItem) => (
  <>
    {isLoading ? (
      <Stack width="100%" alignItems="center" justifyContent="center" height="100%">
        <CircularProgress />
      </Stack>
    ) : (
      <Stack
        direction="row"
        justifyContent={noIcon ? 'center' : 'space-between'}
        alignItems="center"
        height="100%"
      >
        <Stack textAlign={noIcon ? 'center' : 'left'}>
          <Typography
            fontSize={{
              xs: 24,
              md: 45,
            }}
            color={textColor}
          >
            {value}
          </Typography>
          <Typography fontSize={14} color="textSecondary">
            {title}
          </Typography>
        </Stack>
        {!noIcon && <IconBox Icon={Icon} backgroundColor={iconBackgroundColor} />}
      </Stack>
    )}
  </>
)

export default DashboardMainInfoItem
